
function getRequestUrl(){
  const url = window.location.origin;
  if(url.includes('3000')){
    return url.replace('3000','8080');
  }else{
    return '';
  }
}

export const getLogonData = async () =>  await fetch(`${getRequestUrl()}/getLogonData`, {
      method: 'GET',
      credentials: 'include',
      mode: "cors",
      headers: {
         'Access-Control-Allow-Origin': '*',
         'Connection': 'keep-alive'
      }
   })


export const deleteDoc = async (data) => await fetch(`${getRequestUrl()}/postDeleteDoc`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(data)
})   


export const getDocumentDAO = async (request) => await fetch(`${getRequestUrl()}/getDocumentoADeletear?`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})   

export const elegirDoc = async (idDoc) => await fetch(`${getRequestUrl()}/ElegirDocSrv`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   body: new URLSearchParams({
      idDoc: idDoc      
   })
})

export const getCurrentDoc = async () => await fetch(`${getRequestUrl()}/getCurrentDoc`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",   
})
export const getDocumentViewResources = async () => await fetch(`${getRequestUrl()}/getResources`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",   
})


export const getIDsWithError = async (profileName) => await fetch(`${getRequestUrl()}/postDocIdWithErrorCorregido`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(profileName)
})
.then(response => response.json())
.catch(error => console.log("Error in api /postDocIdWithErrorCorregido: " + error));


export const addAttachmentFileImagen = async (formData) => await fetch(`${getRequestUrl()}/invoiceApprovalSystem/addAttachmentFileImagen`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      "Accept-Encoding": "multipart/form-data"
   },
   body: formData /* new FormData({bytes:formData.bytes, filename:formData.filename,invonumb:formData.invonumb, compcode:formData.compcode,ctrycode:formData.ctrycode, 
                              idDoc:formData.idDoc, user:formData.user,})  */
})
   .then(response => response)
   .catch(error => console.log("Error in api /approvers/addAttachmentFileImagen: " + error));

export const deleteAttachmentFileImagen = async (formData) => await fetch(`${getRequestUrl()}/invoiceApprovalSystem/deleteAttachmentFileImagen`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      "Accept-Encoding": "multipart/form-data"
   },
   body: formData /* new FormData({bytes:formData.bytes, filename:formData.filename,invonumb:formData.invonumb, compcode:formData.compcode,ctrycode:formData.ctrycode, 
                                 idDoc:formData.idDoc, user:formData.user,})  */
})
   .then(response => response)
   .catch(error => console.log("Error in api /approvers/addAttachmentFileImagen: " + error));

export const replaceAttachmentFileImagen = async (formData) => await fetch(`${getRequestUrl()}/invoiceApprovalSystem/replaceAttachmentFileImagen`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      "Accept-Encoding": "multipart/form-data"
   },
   body: formData /* new FormData({bytes:formData.bytes, filename:formData.filename,invonumb:formData.invonumb, compcode:formData.compcode,ctrycode:formData.ctrycode, 
                                    idDoc:formData.idDoc, user:formData.user,})  */
})
   .then(response => response)
   .catch(error => console.log("Error in api /approvers/addAttachmentFileImagen: " + error));


export const postUniqueExpenditure = async (data) => await fetch(`${getRequestUrl()}/postExpenditures`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },   
   body: JSON.stringify(data)
})

export const getCountriesList = async () => await fetch(`${getRequestUrl()}/GetCountriesList`, {
   method: 'GET',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   }
})   

export const getCommoditiesList = async (request) => await fetch(`${getRequestUrl()}/getListaCommodities?`+ new URLSearchParams(
   request
), {
   method: 'GET',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   }
})   


export const getOperationsList = async (request) => await fetch(`${getRequestUrl()}/getOperationLog?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
})   

export const getResoucesForViews = async (request) => await fetch(`${getRequestUrl()}/gestorAdmin?`+ new URLSearchParams(
   request
),  {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})   

export const getSupplierAdditionalTaxInformation = async (request) => await fetch(`${getRequestUrl()}/GetDataTaxConditionSrv?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})



export const getRejectInfoToLog = async (request) => await fetch(`${getRequestUrl()}/GetDatosRTVOrHoldSrv?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 

})   

export const getAttachmentsRtvOrHoldLog = async (request) => await fetch(`${getRequestUrl()}/downloadAttachmentRTVOrHoldSrv?`+ new URLSearchParams(
   request
), {
   method: 'GET',
   credentials: 'include',
   mode: "cors", 

})   

export const insertApproverDelegation = async (request) => await fetch(`${getRequestUrl()}/postApproverDelegation`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})   


export const cancelDelegation = async (request) => await fetch(`${getRequestUrl()}/CancelDelegation?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
})   


export const getAllValidationResources = async (request) => await fetch(`${getRequestUrl()}/GetLoggerAllInvoiceSrv?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})   

export const getValidationInvoice = async (request) => await fetch(`${getRequestUrl()}/GetLoggerInvoiceSrv?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})   

export const generateImage = async (request) => await fetch(`${getRequestUrl()}/downloadValidationLogAttachmentSrv?`+ new URLSearchParams(
   request
), {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 

})



export const getListHeaderDocAll = async (ctrycode,days,key) => await fetch(`${getRequestUrl()}/getDocumentos`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   body:  new URLSearchParams({
      key: key,
      pais: ctrycode,
      days: days
   })
})

export const getListDocs = async (user, profileName) => await fetch(`${getRequestUrl()}/getListDocs`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: { 'Content-Type': 'application/json' },
   body:  JSON.stringify({
      user: user,
      profile: profileName
    })
})


export const getKernelIasResources = async () => await fetch(`${getRequestUrl()}/kernelIAs/getKernelIasResources`, {
   method: 'GET',
   credentials: 'include',
   mode: "cors"
})



export const postSubmitLogin = async (username, password) => await fetch(`${getRequestUrl()}/Login?`+ new URLSearchParams({
   j_username: username,
   j_password: password
}), {
   method: 'GET',   
   credentials: 'include',
   mode: "cors"
})
.then(response => response.json())
.catch(error => console.log("Error in api /Login: " + error));

export const getListMailNameEmployeeByKey = async (request) => await fetch(`${getRequestUrl()}/getMailNombreEmpleado?`+ new URLSearchParams(request), {
   method: 'POST',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})


export const responderPedidoSrv = async (request) =>  await fetch(`${getRequestUrl()}/responderPedidoSrv?`, 
{
   method: 'POST',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})


export const postDelegatedUser = async (request) => await fetch(`${getRequestUrl()}/delegateUserSrv?`, 
{
   method: 'POST',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})


export const postMassiveAction = async (request) => await fetch(`${getRequestUrl()}/MasiveAction?`, 
{
   method: 'POST',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})


export const getDelegationList = async () => await fetch(`${getRequestUrl()}/getDelegationList?`, 
{
   method: 'GET',   
   credentials: 'include',
   mode: "cors",      
})

export const getIerpAccountsList = async (accountType,inputText) => 
      await fetch(`${getRequestUrl()}/GetAccountIERPList?`+ new URLSearchParams({
   selectID: accountType,
   searchValue: inputText
}), 
{
   method: 'GET',   
   credentials: 'include',
   mode: "cors",       
})

export const getCategoryCommcodeIerp = async (request) => await fetch(`${getRequestUrl()}/ValidateCategoryCommodityIERP?`+ new URLSearchParams(request), 
{
   method: 'POST',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },   
})


export const postApproverAttachment = async (formData) => await fetch(`${getRequestUrl()}/UploadFilesDocApprover`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      "Accept-Encoding": "multipart/form-data"
   },
   body: formData 
})

export const getListTaxTreatyAttachments = async (request) => await fetch(`${getRequestUrl()}/getTaxTreatyAttachment?`+ new URLSearchParams(
   request
), 
{
   method: 'GET',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },   
})

export const getListInvoiceAttachments = async (request) => await fetch(`${getRequestUrl()}/getInvoiceAttachmentSrv?`+ new URLSearchParams(
   request
), 
{
   method: 'GET',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },   
})

export const postReturnToVendor = async (formData) => await fetch(`${getRequestUrl()}/UploadFilesReject`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      "Accept-Encoding": "multipart/form-data"
   },
   body: formData 
})

export const postCancelReturnToVendor = async (request) => await fetch(`${getRequestUrl()}/CancelarRejectados`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})

export const getRejectionInformation = async (request) => await fetch(`${getRequestUrl()}/getRejectInfo?`+ new URLSearchParams(
   request
), 
{
   method: 'POST',   
   credentials: 'include',
   mode: "cors",
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },   
})

export const getAccountingInformationForView = async (request) => await fetch(`${getRequestUrl()}/getAccountingTablesResourcesForView?`+ new URLSearchParams(
   request
),  {
   method: 'GET',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})  

export const getSupplierTaxAttachment = async (request) => await fetch(`${getRequestUrl()}/downloadTaxConditionAttachment?`+ new URLSearchParams(
   request
), {
   method: 'GET',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
})

export const putRequestForeingEmployee = async (request) => await fetch(`${getRequestUrl()}/postRequestEmpExt?`, {
   method: 'PUT',
   credentials: 'include',
   mode: "cors", 
   headers: {      
      'Content-Type': 'application/x-www-form-urlencoded'
   },
   body: request.toString()
})

export const postIdWithErrorCorrection = async (request) => await fetch(`${getRequestUrl()}/postDocIdWithErrorCorregido?`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors", 
   headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   },
   body: JSON.stringify(request)
})

export const getDocument = async (request) => await fetch(`${getRequestUrl()}/getDocumento?`+ new URLSearchParams(
   request
), {
   method: 'GET',
   credentials: 'include',
   mode: "cors", 
})

export const postSupplierAttachment = async (formData) => await fetch(`${getRequestUrl()}/UploadFilesDocSupplier`, {
   method: 'POST',
   credentials: 'include',
   mode: "cors",
   headers: {
      "Accept-Encoding": "multipart/form-data"
   },
   body: formData 
})

export const getInvoiceCoversheet = async () => await fetch(`${getRequestUrl()}/downloadTicketSrv?`,{
   method: 'GET',
   credentials: 'include',
   mode: "cors", 
})   